import React from "react";

function normalizeStatus(status) {
  const s = (status || "").toLowerCase();
  if (["verified", "confirmed", "success"].includes(s)) return "verified";
  if (s === "submitted") return "submitted";
  if (s === "pending") return "pending";
  if (["unreachable", "failed", "error", "timeout"].includes(s)) return "unreachable";
  return "pending";
}

function statusColor(status) {
  const normalized = normalizeStatus(status);
  if (normalized === "verified") return "#6bff8a";
  if (["pending", "submitted"].includes(normalized)) return "#ffde16";
  return "#ff8a80";
}

function readableStatus(status) {
  const normalized = normalizeStatus(status);
  if (normalized === "verified") return "verified";
  if (normalized === "submitted") return "submitted";
  if (normalized === "pending") return "pending";
  return "unreachable";
}

export default function BlockchainBadge({
  hash,
  status,
  verificationUrl,
  compact = false,
  showStatus = false,
  hideWhenMissing = false,
}) {
  if (!hash && hideWhenMissing) return null;
  if (!hash) return null;

  const short = `${hash.slice(0, 6)}…${hash.slice(-4)}`;
  const label = compact ? short : `sha256: ${short}`;
  const badgeBody = (
    <span className="xs-chain-wrap" data-testid="blockchain-badge" style={{ position: "relative" }}>
      <span
        className="xs-chain"
        tabIndex={0}
        style={{
          background: "#ffde16",
          color: "#000",
          border: "1px solid #ffde16",
          boxShadow: "0 0 18px rgba(255, 222, 22, 0.15)",
        }}
        title={`Blockchain hash ${hash} — ${status || "hashed"}`}
      >
        <span className="xs-chain-dot" />
        ⛓ {label}
      </span>
      <span className="xs-chain-tooltip" role="tooltip" aria-live="polite">
        <strong>Blockchain hash</strong>
        <br />
        <span style={{ wordBreak: "break-all" }}>{hash}</span>
        <span style={{ display: "block", marginTop: 6 }}>
          — <span style={{ color: statusColor(status) }}>{readableStatus(status)}</span>
        </span>
      </span>
    </span>
  );

  if (verificationUrl) {
    return (
      <a href={verificationUrl} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }} aria-label="Open timestamps verification">
        {badgeBody}
      </a>
    );
  }

  if (showStatus) {
    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        {badgeBody}
        <span style={{ color: statusColor(status), fontWeight: 700 }}>
          {readableStatus(status)}
        </span>
      </span>
    );
  }

  return badgeBody;
}
